// Smartworld Group - Bilingual content data (EN / FR)
// All localized text fields are exported as { en: ..., fr: ... } objects.
// Shared fields (id, color, image URLs, brand name, year, numeric values) stay flat.

export const siteData = {
  companyName: "Smartworld Group",
  emails: {
    careers: "careers@smartworld.group",
    contact: "contact@smartworld.group",
    info: "info@smartworldgroup.com"
  },
  website: "smartworldgroup.com",
  tagline: {
    en: "Building Africa's Integrated Future.",
    fr: "Construire l'avenir intégré de l'Afrique."
  },
  subTagline: {
    en: "Real assets. Digital infrastructure. Long-term vision.",
    fr: "Actifs réels. Infrastructure numérique. Vision long terme."
  }
};

// Leadership Team - SWG
export const leadershipTeam = [
  {
    id: "alpha-diallo",
    name: "Alpha Diallo",
    image: "https://customer-assets.emergentagent.com/job_pan-african-group/artifacts/aq0ncv9d_56e32d94-1259-46d1-94dc-b90d198a20ee.jpeg",
    title: {
      en: "Director & Chairman",
      fr: "Directeur & Président"
    },
    bio: {
      en: "An Ivorian-born global citizen, renowned entrepreneur, visionary, and connector/facilitator. He is passionate about economic expansion, social inclusion, and peace. Director and Chairman of a multi-sector holding company operating on the African continent that specialises in Land Development, Energy and Fintech.",
      fr: "Citoyen du monde né en Côte d'Ivoire, entrepreneur reconnu, visionnaire et facilitateur. Passionné par l'expansion économique, l'inclusion sociale et la paix. Directeur et Président d'un holding multisectoriel opérant sur le continent africain, spécialisé dans le développement foncier, l'énergie et la fintech."
    }
  }
];

// Smartland Leadership
export const smartlandLeadership = [
  {
    id: "alpha-diallo",
    name: "Alpha Diallo",
    image: "https://customer-assets.emergentagent.com/job_pan-african-group/artifacts/aq0ncv9d_56e32d94-1259-46d1-94dc-b90d198a20ee.jpeg",
    title: { en: "Founder & Chairman", fr: "Fondateur & Président" },
    bio: {
      en: "An Ivorian-born global citizen, renowned entrepreneur, visionary, and connector/facilitator passionate about economic expansion and social inclusion.",
      fr: "Citoyen du monde né en Côte d'Ivoire, entrepreneur reconnu, visionnaire et facilitateur, passionné par l'expansion économique et l'inclusion sociale."
    }
  },
  {
    id: "greg-scott",
    name: "Greg Scott",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop",
    title: { en: "Co-Founder, Smartland", fr: "Co-fondateur, Smartland" },
    bio: {
      en: "Founder of Scott and Partners, a planning, architectural and interior design studio dedicated to producing exceptional, progressive, and beautiful solutions. Their project work is underpinned by a rigorous process of solution-based application.",
      fr: "Fondateur de Scott and Partners, un studio d'urbanisme, d'architecture et de design intérieur dédié à la création de solutions exceptionnelles, progressistes et élégantes. Leur travail repose sur une démarche rigoureuse axée sur la solution."
    }
  }
];

// Key Statistics
export const keyStats = [
  { value: "8", suffix: "", label: { en: "Specialized Companies", fr: "Entreprises spécialisées" } },
  { value: "2000", suffix: "+", label: { en: "Hectares Developed", fr: "Hectares développés" } },
  { value: "5", suffix: "+", label: { en: "African Countries", fr: "Pays africains" } },
  { value: "12", suffix: "+", label: { en: "Years of Experience", fr: "Années d'expérience" } }
];

// Timeline / Milestones - Smartland
export const smartlandTimeline = [
  {
    year: "2012",
    title: { en: "Foundation", fr: "Fondation" },
    description: {
      en: "Founding of Smartland International headquartered in Cape Town with Greg Scott.",
      fr: "Création de Smartland International dont le siège est au Cap, avec Greg Scott."
    }
  },
  {
    year: "2013-2015",
    title: { en: "Centenary City Abuja", fr: "Centenary City Abuja" },
    description: {
      en: "Master planning and full city development plan of Centenary City Abuja (2,000 hectares).",
      fr: "Plan directeur et développement urbain complet de Centenary City Abuja (2 000 hectares)."
    }
  },
  {
    year: "2016",
    title: { en: "Bemfinca Bay", fr: "Bemfinca Bay" },
    description: {
      en: "Master plan & site development plan of Bemfinca Bay in Luanda (250 hectares).",
      fr: "Plan directeur et plan d'aménagement du site de Bemfinca Bay à Luanda (250 hectares)."
    }
  },
  {
    year: "2017-2019",
    title: { en: "Expansion", fr: "Expansion" },
    description: {
      en: "Hotel development in Abuja with Starwood hotels. City Mall in Abakaliki, Nigeria. Master planning of City of Pembe in Mozambique.",
      fr: "Développement hôtelier à Abuja avec Starwood. City Mall à Abakaliki, Nigéria. Plan directeur de la City of Pembe au Mozambique."
    }
  },
  {
    year: "2020-2023",
    title: { en: "Côte d'Ivoire Operations", fr: "Opérations en Côte d'Ivoire" },
    description: {
      en: "Land optimization and planning on 470 hectares. Design of Hillside residential project in Cocody, Abidjan.",
      fr: "Optimisation et planification foncière sur 470 hectares. Conception du projet résidentiel Hillside à Cocody, Abidjan."
    }
  },
  {
    year: "2024-2027",
    title: { en: "Future Projects", fr: "Projets futurs" },
    description: {
      en: "Mixed-use development on 30 hectares in Port-Bouet. Office building in Plateau, Abidjan.",
      fr: "Projet mixte sur 30 hectares à Port-Bouët. Immeuble de bureaux au Plateau, Abidjan."
    }
  }
];

// Partners
export const partners = [
  { name: "Starwood Hotels", logo: null },
  { name: "Scott and Partners", logo: null }
];

// Testimonials
export const testimonials = [
  {
    author: "Françoise Akinosho",
    role: { en: "Architect", fr: "Architecte" },
    quote: {
      en: "Their project work is underpinned by a rigorous process of solution-based application in an ongoing quest to develop elegant, anti-formulaic buildings, spaces, installations and objects that exceed client expectations and make a meaningful contribution to the environment.",
      fr: "Leur travail repose sur une démarche rigoureuse, fondée sur la solution, dans une quête constante de bâtiments, espaces, installations et objets élégants et non conventionnels qui dépassent les attentes des clients et apportent une contribution significative à leur environnement."
    }
  }
];

// Home Page Content
export const homeContent = {
  hero: {
    title: {
      en: "Building Africa's Integrated Future.",
      fr: "Construire l'avenir intégré de l'Afrique."
    },
    subtitle: {
      en: "Real assets. Digital infrastructure. Long-term vision.",
      fr: "Actifs réels. Infrastructure numérique. Vision long terme."
    }
  },
  introduction: {
    title: { en: "Who We Are", fr: "Qui sommes-nous" },
    text: {
      en: "Smartworld Group (SWG) is a next-generation Pan-African holding company built as an integrated ecosystem. We design, finance, operate and connect real-world infrastructures across key sectors of development — from real estate and energy to logistics, aviation and advanced technology.",
      fr: "Smartworld Group (SWG) est une holding panafricaine de nouvelle génération conçue comme un écosystème intégré. Nous concevons, finançons, exploitons et connectons des infrastructures réelles dans des secteurs clés du développement — de l'immobilier à l'énergie, en passant par la logistique, l'aviation et les technologies avancées."
    },
    vision: {
      en: "Our ambition is simple and demanding: to build scalable, sovereign and future-ready platforms that anchor Africa in the global economy.",
      fr: "Notre ambition est simple et exigeante : bâtir des plateformes scalables, souveraines et prêtes pour l'avenir qui ancrent l'Afrique dans l'économie mondiale."
    }
  },
  ecosystem: {
    title: { en: "The Ecosystem", fr: "L'Écosystème" },
    text: {
      en: "Smartworld Group operates through eight specialized companies, each autonomous, yet strategically interconnected. Together, they form a coherent system where infrastructure, finance, logistics, energy and technology reinforce one another.",
      fr: "Smartworld Group opère à travers huit entreprises spécialisées, chacune autonome mais stratégiquement interconnectée. Ensemble, elles forment un système cohérent où infrastructure, finance, logistique, énergie et technologie se renforcent mutuellement."
    }
  },
  whyUs: {
    title: { en: "Why Smartworld Group", fr: "Pourquoi Smartworld Group" },
    points: {
      en: [
        "Integrated, not fragmented",
        "Real assets connected to digital infrastructure",
        "Pan-African by design, global by execution",
        "Long-term value creation over short-term speculation"
      ],
      fr: [
        "Intégré, et non fragmenté",
        "Des actifs réels connectés à l'infrastructure numérique",
        "Panafricain par conception, mondial par l'exécution",
        "Création de valeur à long terme plutôt que spéculation"
      ]
    }
  },
  mission: {
    en: "Our mission is to harness the vast scope and potential of the African continent as one of the fastest developing growth markets in the world by bringing together leading experts in various fields to make change for good, championing the idea of 'Made in Africa for the world' and targeting the Global South: Africa, Middle East and South America.",
    fr: "Notre mission est de mettre à profit l'étendue et le potentiel du continent africain — l'un des marchés en croissance les plus rapides au monde — en rassemblant des experts de premier plan dans divers domaines pour conduire un changement positif, en défendant l'idée du « Fabriqué en Afrique pour le monde » et en ciblant les Suds : Afrique, Moyen-Orient et Amérique du Sud."
  }
};

// About Page Content
export const aboutContent = {
  whoWeAre: {
    title: { en: "Who We Are", fr: "Qui sommes-nous" },
    text: {
      en: "Smartworld Group is a Pan-African holding company focused on infrastructure, investment and innovation. We operate at the intersection of the real economy and emerging digital systems, building platforms designed to last.",
      fr: "Smartworld Group est une holding panafricaine centrée sur l'infrastructure, l'investissement et l'innovation. Nous opérons à l'intersection de l'économie réelle et des systèmes numériques émergents, en bâtissant des plateformes conçues pour durer."
    }
  },
  vision: {
    title: { en: "Vision", fr: "Vision" },
    text: {
      en: "To establish Smartworld Group as a reference African group, capable of structuring complex projects, mobilizing capital, and delivering impact at scale.",
      fr: "Faire de Smartworld Group un groupe africain de référence, capable de structurer des projets complexes, de mobiliser des capitaux et de délivrer un impact à grande échelle."
    }
  },
  mission: {
    title: { en: "Mission", fr: "Mission" },
    points: {
      en: [
        "Build real-world infrastructure across strategic sectors",
        "Design integrated economic models rather than isolated projects",
        "Enable Africa-to-World connectivity through logistics, finance and technology",
        "Create durable value for partners, investors and communities"
      ],
      fr: [
        "Bâtir des infrastructures réelles dans des secteurs stratégiques",
        "Concevoir des modèles économiques intégrés plutôt que des projets isolés",
        "Permettre la connectivité Afrique-Monde grâce à la logistique, la finance et la technologie",
        "Créer une valeur durable pour les partenaires, les investisseurs et les communautés"
      ]
    }
  },
  model: {
    title: { en: "Our Model", fr: "Notre modèle" },
    intro: { en: "SWG follows an ecosystem logic:", fr: "SWG suit une logique d'écosystème :" },
    points: {
      en: [
        "Each subsidiary has a clear mandate",
        "Synergies are intentional, not accidental",
        "Finance, logistics, energy and technology are shared layers",
        "Innovation is applied, not abstract"
      ],
      fr: [
        "Chaque filiale a un mandat clair",
        "Les synergies sont intentionnelles, jamais accidentelles",
        "Finance, logistique, énergie et technologie sont des couches partagées",
        "L'innovation est appliquée, jamais abstraite"
      ]
    }
  },
  governance: {
    title: { en: "Governance & Values", fr: "Gouvernance & Valeurs" },
    points: {
      en: [
        "Long-term vision",
        "Operational discipline",
        "Transparency and accountability",
        "Responsible growth",
        "Strategic partnerships"
      ],
      fr: [
        "Vision long terme",
        "Discipline opérationnelle",
        "Transparence et responsabilité",
        "Croissance responsable",
        "Partenariats stratégiques"
      ]
    }
  }
};

// Ecosystem Page Content
export const ecosystemContent = {
  title: { en: "The Ecosystem", fr: "L'Écosystème" },
  intro: {
    title: { en: "An Integrated Approach", fr: "Une approche intégrée" },
    text: {
      en: "Smartworld Group does not operate as a collection of unrelated businesses. We build interoperable platforms where each activity strengthens the others.",
      fr: "Smartworld Group n'opère pas comme une simple collection d'entreprises distinctes. Nous bâtissons des plateformes interopérables où chaque activité renforce les autres."
    },
    connections: {
      en: [
        "Real estate connects to energy.",
        "Logistics connects to aviation.",
        "Finance connects to real assets.",
        "Technology connects everything."
      ],
      fr: [
        "L'immobilier se connecte à l'énergie.",
        "La logistique se connecte à l'aviation.",
        "La finance se connecte aux actifs réels.",
        "La technologie connecte tout."
      ]
    }
  },
  valueCreation: {
    title: { en: "Value Creation", fr: "Création de valeur" },
    intro: { en: "This integrated model allows:", fr: "Ce modèle intégré permet :" },
    points: {
      en: [
        "Lower execution risk",
        "Better capital efficiency",
        "Faster scaling",
        "Stronger resilience across cycles"
      ],
      fr: [
        "Un risque d'exécution réduit",
        "Une meilleure efficience du capital",
        "Une mise à l'échelle plus rapide",
        "Une résilience renforcée à travers les cycles"
      ]
    }
  }
};

// Subsidiaries (each item: shared fields + i18n object for text)
export const subsidiaries = [
  {
    id: "smartland",
    name: "Smartland",
    color: "#E07B54",
    logo: "/logos/smartland.png",
    customIcon: "/logos/smartland-icon.png",
    i18n: {
      en: {
        tagline: "Real Estate & Urban Development",
        about: "With a focus on sustainable and innovative design, Smartland International provides turnkey solutions for every aspect of the development process, from planning and design to construction and management.",
        fullDescription: "Smartland is the real estate and urban development arm of Smartworld Group. We design and deliver mixed-use developments, hospitality assets, urban projects and infrastructures aligned with long-term economic and social value creation.",
        coreActivities: [
          "Mixed-use real estate developments",
          "Hospitality and branded residences",
          "Urban regeneration and master planning",
          "Sustainable and smart infrastructure integration"
        ],
        strategicFocus: [
          "Prime urban locations",
          "Hospitality and lifestyle assets",
          "Long-term real estate value",
          "ESG-aligned development"
        ],
        valueProposition: "Smartland develops projects that are financially sound, architecturally relevant and operationally sustainable, fully integrated into the broader Smartworld ecosystem.",
        principle: "Land-Value Capture, or LVC, is the overriding principle that guides our process. It ensures that the inherent value and equity so often locked into land is identified and unlocked."
      },
      fr: {
        tagline: "Immobilier & Développement urbain",
        about: "Axée sur le design durable et innovant, Smartland International offre des solutions clés en main pour chaque étape du processus de développement, de la planification et de la conception à la construction et à la gestion.",
        fullDescription: "Smartland est le pôle immobilier et de développement urbain de Smartworld Group. Nous concevons et livrons des projets mixtes, des actifs hôteliers, des projets urbains et des infrastructures alignés sur la création de valeur économique et sociale de long terme.",
        coreActivities: [
          "Développements immobiliers mixtes",
          "Hôtellerie et résidences de marque",
          "Régénération urbaine et planification directrice",
          "Intégration d'infrastructures durables et intelligentes"
        ],
        strategicFocus: [
          "Emplacements urbains de premier rang",
          "Actifs d'hospitalité et lifestyle",
          "Valeur immobilière long terme",
          "Développement aligné ESG"
        ],
        valueProposition: "Smartland développe des projets financièrement solides, architecturalement pertinents et opérationnellement durables, pleinement intégrés à l'écosystème Smartworld.",
        principle: "Le Land-Value Capture (LVC) est le principe directeur de notre démarche. Il garantit que la valeur intrinsèque souvent figée dans le foncier est identifiée et libérée."
      }
    }
  },
  {
    id: "smartmart",
    name: "Smartmart",
    color: "#E05A4E",
    logo: "/logos/smartmart.png",
    customIcon: "/logos/smartmart-icon.png",
    i18n: {
      en: {
        tagline: "Retail & Distribution Platforms",
        about: "With a focus on customer satisfaction, Smartmart provides access to a diverse range of high-quality and affordable products through a convenient shopping experience.",
        fullDescription: "Smartmart develops modern retail and distribution platforms connecting production to consumers across Africa.",
        coreActivities: [
          "Food and consumer goods distribution",
          "Proximity retail concepts",
          "Integrated supply chains",
          "Digital ordering and fulfillment"
        ],
        strategicFocus: [
          "Urban and peri-urban markets",
          "Reliable supply and quality control",
          "Scalable retail models"
        ],
        valueProposition: "Smartmart bridges local production and modern consumption through efficient, tech-enabled distribution."
      },
      fr: {
        tagline: "Distribution & Plateformes retail",
        about: "Centrée sur la satisfaction client, Smartmart donne accès à une gamme variée de produits de qualité à prix abordables, dans une expérience d'achat fluide et pratique.",
        fullDescription: "Smartmart développe des plateformes modernes de retail et de distribution reliant la production aux consommateurs à travers l'Afrique.",
        coreActivities: [
          "Distribution alimentaire et grande consommation",
          "Concepts de retail de proximité",
          "Chaînes d'approvisionnement intégrées",
          "Commande et logistique digitales"
        ],
        strategicFocus: [
          "Marchés urbains et péri-urbains",
          "Approvisionnement fiable et contrôle qualité",
          "Modèles de retail scalables"
        ],
        valueProposition: "Smartmart relie la production locale et la consommation moderne par une distribution efficiente et technologique."
      }
    }
  },
  {
    id: "smartinvest",
    name: "Smartinvest",
    color: "#C4A35A",
    logo: "/logos/smartinvest.png",
    customIcon: "/logos/smartinvest-icon.png",
    i18n: {
      en: {
        tagline: "Finance & Asset Structuring",
        about: "Whether you are a tech startup, a social enterprise, or a high-growth business, Smartinvest will help you achieve your goals and drive economic growth in Africa.",
        fullDescription: "Smartinvest is the financial engineering and asset structuring platform of Smartworld Group.",
        coreActivities: [
          "Investment structuring",
          "Asset-backed financial vehicles",
          "Capital aggregation",
          "Tokenization-ready frameworks"
        ],
        strategicFocus: [
          "Infrastructure and real assets",
          "Emerging markets finance",
          "Innovative investment models"
        ],
        valueProposition: "Smartinvest transforms real economic assets into structured, investable and scalable opportunities."
      },
      fr: {
        tagline: "Finance & Structuration d'actifs",
        about: "Que vous soyez une startup tech, une entreprise sociale ou une société à forte croissance, Smartinvest vous aide à atteindre vos objectifs et à stimuler la croissance économique en Afrique.",
        fullDescription: "Smartinvest est la plateforme d'ingénierie financière et de structuration d'actifs de Smartworld Group.",
        coreActivities: [
          "Structuration d'investissements",
          "Véhicules financiers adossés à des actifs",
          "Agrégation de capitaux",
          "Cadres prêts pour la tokenisation"
        ],
        strategicFocus: [
          "Infrastructures et actifs réels",
          "Finance des marchés émergents",
          "Modèles d'investissement innovants"
        ],
        valueProposition: "Smartinvest transforme les actifs économiques réels en opportunités structurées, investissables et scalables."
      }
    }
  },
  {
    id: "smartmedias",
    name: "Smartmedias",
    color: "#D4A54A",
    logo: "/logos/smartmedias.png",
    customIcon: "/logos/smartmedias-icon.png",
    i18n: {
      en: {
        tagline: "Media, Communication & Narrative Infrastructure",
        about: "With a focus on quality journalism, Smartmedias aims to inform, educate, and entertain our audiences through our diverse media offerings, which include news, current affairs, entertainment, and lifestyle content.",
        fullDescription: "Smartmedias develops media platforms and communication strategies that support brands, projects and narratives aligned with Africa's transformation.",
        coreActivities: [
          "Publishing and content platforms",
          "Corporate communication",
          "Brand strategy",
          "Digital media production"
        ],
        strategicFocus: [
          "Positive, forward-looking narratives",
          "Business and innovation storytelling",
          "Pan-African reach"
        ],
        valueProposition: "Smartmedias builds clarity, credibility and influence through strategic communication."
      },
      fr: {
        tagline: "Médias, Communication & Infrastructure narrative",
        about: "Centrée sur un journalisme de qualité, Smartmedias informe, éduque et divertit ses publics à travers une offre médiatique variée — actualités, débats, divertissement et lifestyle.",
        fullDescription: "Smartmedias développe des plateformes médias et des stratégies de communication qui soutiennent les marques, projets et récits alignés sur la transformation de l'Afrique.",
        coreActivities: [
          "Plateformes d'édition et de contenu",
          "Communication corporate",
          "Stratégie de marque",
          "Production média digitale"
        ],
        strategicFocus: [
          "Récits positifs et tournés vers l'avenir",
          "Storytelling business et innovation",
          "Portée panafricaine"
        ],
        valueProposition: "Smartmedias construit clarté, crédibilité et influence par la communication stratégique."
      }
    }
  },
  {
    id: "smartenergies",
    name: "Smartenergies",
    color: "#7CB342",
    logo: "/logos/smartenergies.png",
    customIcon: "/logos/smartenergies-icon.png",
    i18n: {
      en: {
        tagline: "Energy & Sustainable Infrastructure",
        about: "With a focus on renewable energy sources that reduce carbon emissions, Smartenergies provides affordable and reliable energy solutions for households, businesses, and communities across Africa.",
        fullDescription: "Smartenergies develops energy solutions and infrastructure projects designed to support industrial and urban growth.",
        coreActivities: [
          "Renewable energy projects",
          "Decentralized energy systems",
          "Smart infrastructure integration"
        ],
        strategicFocus: [
          "Sustainability and resilience",
          "Infrastructure reliability",
          "Long-term energy security"
        ],
        valueProposition: "Smartenergies delivers practical, scalable and future-proof energy infrastructure."
      },
      fr: {
        tagline: "Énergie & Infrastructure durable",
        about: "Centrée sur les sources d'énergie renouvelable qui réduisent les émissions de carbone, Smartenergies fournit des solutions énergétiques fiables et abordables aux ménages, aux entreprises et aux communautés à travers l'Afrique.",
        fullDescription: "Smartenergies développe des solutions énergétiques et des projets d'infrastructure conçus pour soutenir la croissance industrielle et urbaine.",
        coreActivities: [
          "Projets d'énergie renouvelable",
          "Systèmes énergétiques décentralisés",
          "Intégration d'infrastructures intelligentes"
        ],
        strategicFocus: [
          "Durabilité et résilience",
          "Fiabilité des infrastructures",
          "Sécurité énergétique long terme"
        ],
        valueProposition: "Smartenergies livre une infrastructure énergétique pragmatique, scalable et durable."
      }
    }
  },
  {
    id: "smartlogistics",
    name: "Smartlogistics",
    color: "#4DB6AC",
    logo: "/logos/smartlogistics.png",
    customIcon: "/logos/smartlogistics-icon.png",
    i18n: {
      en: {
        tagline: "Transport & Supply Chain Solutions",
        about: "Smartlogistics provides comprehensive transportation and supply chain solutions to businesses across the continent. Our advanced technology ensures your goods are delivered safely and cost-effectively, to city centres as well as hard-to-reach locations.",
        fullDescription: "Smartlogistics structures logistics and supply chain platforms enabling efficient movement of goods across regions.",
        coreActivities: [
          "Logistics hubs",
          "Trade corridors",
          "Supply chain optimization",
          "Digital logistics systems"
        ],
        strategicFocus: [
          "Africa–World connectivity",
          "Trade facilitation",
          "Cost and time efficiency"
        ],
        valueProposition: "Smartlogistics turns logistics into a strategic advantage, not a bottleneck."
      },
      fr: {
        tagline: "Transport & Solutions Supply Chain",
        about: "Smartlogistics offre des solutions complètes de transport et de chaîne d'approvisionnement aux entreprises de tout le continent. Notre technologie de pointe garantit une livraison sûre et économique de vos marchandises, en centre-ville comme dans les zones difficiles d'accès.",
        fullDescription: "Smartlogistics structure des plateformes logistiques et supply chain qui permettent un mouvement efficace des marchandises à travers les régions.",
        coreActivities: [
          "Hubs logistiques",
          "Corridors commerciaux",
          "Optimisation supply chain",
          "Systèmes logistiques digitaux"
        ],
        strategicFocus: [
          "Connectivité Afrique–Monde",
          "Facilitation des échanges",
          "Efficience coût et temps"
        ],
        valueProposition: "Smartlogistics fait de la logistique un avantage stratégique, et non un goulot d'étranglement."
      }
    }
  },
  {
    id: "smartaviation",
    name: "Smartaviation",
    color: "#5C9EE0",
    logo: "/logos/smartaviation.png",
    customIcon: "/logos/smartaviation-icon.png",
    i18n: {
      en: {
        tagline: "Private & Cargo Aviation",
        about: "Business or pleasure, charter or cargo, Smartaviation's experienced professionals are committed to getting you where you need to be.",
        fullDescription: "Smartaviation provides aviation solutions supporting mobility, logistics and strategic connectivity.",
        coreActivities: [
          "Private aviation services",
          "Cargo and specialized transport",
          "Strategic air connectivity"
        ],
        strategicFocus: [
          "High-value cargo",
          "Premium mobility",
          "Inter-hub connections"
        ],
        valueProposition: "Smartaviation delivers reliable, secure and strategic air mobility within the Smartworld ecosystem."
      },
      fr: {
        tagline: "Aviation privée & cargo",
        about: "Affaires ou loisirs, charter ou cargo, les professionnels expérimentés de Smartaviation s'engagent à vous amener exactement où vous devez être.",
        fullDescription: "Smartaviation fournit des solutions d'aviation soutenant la mobilité, la logistique et la connectivité stratégique.",
        coreActivities: [
          "Services d'aviation privée",
          "Cargo et transport spécialisé",
          "Connectivité aérienne stratégique"
        ],
        strategicFocus: [
          "Cargo à forte valeur ajoutée",
          "Mobilité premium",
          "Connexions inter-hubs"
        ],
        valueProposition: "Smartaviation offre une mobilité aérienne fiable, sécurisée et stratégique au sein de l'écosystème Smartworld."
      }
    }
  },
  {
    id: "smartlab",
    name: "Smartlab",
    color: "#4A90D9",
    logo: "/logos/smartlab.png",
    customIcon: "/logos/smartlab-icon.png",
    i18n: {
      en: {
        tagline: "Innovation, AI, Biotech & Advanced R&D",
        about: "Smartlab provides a collaborative space for startups and entrepreneurs to innovate and develop cutting-edge technology and biotech solutions.",
        fullDescription: "Smartlab is the innovation and research hub of Smartworld Group.",
        coreActivities: [
          "Artificial intelligence",
          "Blockchain and digital infrastructure",
          "Advanced data systems",
          "Biotech & medical R&D",
          "Applied R&D"
        ],
        strategicFocus: [
          "Real-world applications",
          "Infrastructure-grade technology",
          "Long-term innovation"
        ],
        valueProposition: "Smartlab ensures Smartworld Group remains technologically ahead, operationally efficient and future-ready."
      },
      fr: {
        tagline: "Innovation, IA, Biotech & R&D avancée",
        about: "Smartlab offre un espace collaboratif aux startups et entrepreneurs pour innover et développer des solutions technologiques et biotech de pointe.",
        fullDescription: "Smartlab est le hub d'innovation et de recherche de Smartworld Group.",
        coreActivities: [
          "Intelligence artificielle",
          "Blockchain et infrastructure numérique",
          "Systèmes de données avancés",
          "Biotech & R&D médicale",
          "R&D appliquée"
        ],
        strategicFocus: [
          "Applications concrètes",
          "Technologie de niveau infrastructure",
          "Innovation long terme"
        ],
        valueProposition: "Smartlab maintient Smartworld Group en avance technologique, opérationnellement efficace et prêt pour l'avenir."
      }
    }
  }
];

// Careers Page Content
export const careersContent = {
  title: { en: "Careers", fr: "Carrières" },
  headline: { en: "Build the Future with Us", fr: "Bâtissez l'avenir avec nous" },
  text: {
    en: "Smartworld Group attracts builders, operators and thinkers who want to work on real projects with long-term impact.",
    fr: "Smartworld Group attire les bâtisseurs, les opérateurs et les penseurs qui souhaitent travailler sur des projets concrets à impact long terme."
  },
  values: {
    en: "We value responsibility, clarity and execution.",
    fr: "Nous valorisons la responsabilité, la clarté et l'exécution."
  },
  email: "careers@smartworld.group"
};

// Partnerships Page Content
export const partnershipsContent = {
  title: { en: "Partnerships", fr: "Partenariats" },
  headline: { en: "Strategic Partnerships", fr: "Partenariats stratégiques" },
  text: {
    en: "We collaborate with investors, technology partners, infrastructure operators, institutions and governments.",
    fr: "Nous collaborons avec des investisseurs, des partenaires technologiques, des opérateurs d'infrastructure, des institutions et des gouvernements."
  },
  approach: {
    en: "Our partnerships are built on alignment, discipline and shared long-term objectives.",
    fr: "Nos partenariats reposent sur l'alignement, la discipline et des objectifs partagés à long terme."
  }
};

// Veena — featured platform of the Smartlab subsidiary (Quantum computing accessible)
export const veenaPlatform = {
  url: "https://veena-analysis.preview.emergentagent.com/",
  name: "veena",
  logo: "/images/veena-logo.svg",
  preview: "/images/veena-preview.png",
  eyebrow: {
    en: "Featured platform",
    fr: "Plateforme phare"
  },
  tagline: {
    en: "Quantum is here",
    fr: "Quantum is here"
  },
  subtagline: {
    en: "Quantum computing, finally accessible.",
    fr: "Le quantique, enfin accessible."
  },
  shortBrief: {
    en: "Solve complex problems — optimization, simulation, ML, finance, logistics — using quantum computing, no technical expertise needed. Pay per result, or subscribe.",
    fr: "Résolvez vos problèmes complexes (optimisation, simulation, ML, finance, logistique) grâce au calcul quantique. Sans expertise technique. Payez aux résultats, ou abonnez-vous."
  },
  longBrief: {
    en: "veena makes the power of quantum computing accessible to everyone, without technical expertise. Submit a complex problem — optimization, simulation, machine learning, finance, logistics — and receive automated analysis and results, executed on cutting-edge quantum algorithms (QAOA, Grover, Trotter). Pay only for results you receive, or choose a subscription tailored to your needs.",
    fr: "veena rend la puissance du calcul quantique accessible à tous, sans expertise technique. Soumettez un problème complexe — optimisation, simulation, machine learning, finance, logistique — et recevez une analyse et des résultats automatisés, exécutés sur des algorithmes quantiques de pointe (QAOA, Grover, Trotter). Payez uniquement pour vos résultats, ou choisissez un abonnement adapté à vos besoins."
  },
  domains: [
    { name: { en: "Optimization", fr: "Optimisation" } },
    { name: { en: "Simulation", fr: "Simulation" } },
    { name: { en: "Machine Learning", fr: "Machine Learning" } },
    { name: { en: "Finance", fr: "Finance" } },
    { name: { en: "Logistics", fr: "Logistique" } }
  ],
  algorithms: ["QAOA", "Grover", "Trotter"],
  pricing: {
    en: ["Pay-per-result", "Or flexible subscription"],
    fr: ["Paiement à l'usage", "Ou abonnement flexible"]
  },
  cta: { en: "Discover veena", fr: "Découvrir veena" },
  brandColor: "#FF6B00",
  bgDark: "#0c1929"
};

// Oceana — featured platform of the Smartmart subsidiary (Retail & Distribution)
export const oceanaPlatform = {
  url: "https://oceana-ci.com",
  name: "Océana",
  logo: "https://customer-assets.emergentagent.com/job_e0d36ff9-afe9-42cc-acb6-596aa3a8fe6f/artifacts/a4fe02wq_5FC0A507-E68A-4817-932C-E6489BAFD800.png",
  eyebrow: {
    en: "Featured Platform · Côte d'Ivoire",
    fr: "Plateforme phare · Côte d'Ivoire"
  },
  tagline: {
    en: "Premium Fruits & Vegetables in Abidjan",
    fr: "Fruits & Légumes Premium à Abidjan"
  },
  shortBrief: {
    en: "Trusted supplier for hotels, restaurants and individuals. B2B distribution, produce stores and enterprise services.",
    fr: "Fournisseur de confiance pour hôtels, restaurants et particuliers. Distribution B2B, boutiques primeur et services entreprises."
  },
  longBrief: {
    en: "Océana is the leader in premium fruit and vegetable distribution in Côte d'Ivoire. With over 15 years of experience, Océana serves professionals (hotels, restaurants, caterers, businesses) and individuals with a range of top-quality fresh products.",
    fr: "Océana est le leader de la distribution de fruits et légumes premium en Côte d'Ivoire. Avec plus de 15 ans d'expérience, Océana accompagne les professionnels (hôtels, restaurants, traiteurs, entreprises) et les particuliers avec une gamme de produits frais de première qualité."
  },
  services: [
    {
      icon: "Building",
      name: { en: "B2B Distribution", fr: "Distribution B2B" },
      desc: { en: "Regular supply for professionals", fr: "Approvisionnement régulier pour professionnels" }
    },
    {
      icon: "Store",
      name: { en: "Fraîcheurs d'Océana", fr: "Fraîcheurs d'Océana" },
      desc: { en: "Produce stores with fresh juices", fr: "Boutiques primeur avec jus frais" }
    },
    {
      icon: "Sprout",
      name: { en: "Océana Production", fr: "Océana Production" },
      desc: { en: "3 hectares of hydroponic greenhouses in Azaguié", fr: "3 hectares de serres hydroponiques à Azaguié" }
    },
    {
      icon: "Package",
      name: { en: "Enterprise Services", fr: "Services Entreprises" },
      desc: { en: "Fruit baskets, meeting platters", fr: "Corbeilles de fruits, plateaux meeting" }
    }
  ],
  stats: [
    { value: "450+", label: { en: "B2B Clients", fr: "Clients B2B" } },
    { value: "15+", label: { en: "Years of Experience", fr: "Années d'expérience" } },
    { value: "98%", label: { en: "Satisfaction Rate", fr: "Satisfaction" } }
  ],
  colors: {
    primary: "#007668",
    dark: "#004833",
    accent: "#F2AD04",
    cream: "#FEF6E8"
  },
  cta: { en: "Visit Océana", fr: "Visiter Océana" }
};

// AEDIS — featured platform of the Smartland subsidiary (Infrastructure Engineering)
export const aedisPlatform = {
  url: "https://corporate-build-4.preview.emergentagent.com",
  name: "AEDIS",
  logo: "/images/aedis-logo.png",
  preview: "/images/aedis-preview.png",
  brandColor: "#C8612A",
  accentColor: "#7A2E3F",
  eyebrow: {
    en: "Infrastructure Engineering & Development",
    fr: "Ingénierie & développement d'infrastructure"
  },
  tagline: {
    en: "Build. Maintain. Develop.",
    fr: "Construire. Maintenir. Développer."
  },
  signature: {
    en: "From the ground to orbit.",
    fr: "Du sol à l'orbite."
  },
  shortBrief: {
    en: "Smartland's infrastructure arm — engineering, building and operating critical infrastructure: civil engineering, energy, water, public facilities, and now space ports.",
    fr: "La filiale infrastructure de Smartland. Société d'ingénierie et de construction, AEDIS conçoit, réalise et exploite des infrastructures critiques : génie civil, énergie, eau, équipements publics, et désormais space ports."
  },
  longBrief: {
    en: "AEDIS is a subsidiary of Smartland dedicated to the construction, maintenance and development of critical works. It operates across six expertise domains and carries a strategic vertical dedicated to Space Ports — ground infrastructure for the emerging space industry. Disciplined execution and long-term partnerships.",
    fr: "Filiale du groupe Smartland, AEDIS est une société d'infrastructure dédiée à la construction, à la maintenance et au développement d'ouvrages critiques. Elle opère sur six domaines d'expertise et porte un vertical stratégique dédié aux Space Ports — infrastructures sol pour l'industrie spatiale émergente. Exécution disciplinée et partenariats long terme."
  },
  domains: [
    { id: "construction",  icon: "HardHat",     name: { en: "Construction & Civil Engineering",  fr: "Construction & Génie civil" } },
    { id: "maintenance",   icon: "Wrench",      name: { en: "Maintenance & Operations",          fr: "Maintenance & Exploitation" } },
    { id: "water",         icon: "Droplets",    name: { en: "Water & Environment",                fr: "Eau & Environnement" } },
    { id: "public",        icon: "Building",    name: { en: "Public Facilities & Buildings",      fr: "Équipements publics & Bâtiments" } },
    { id: "energy",        icon: "Zap",         name: { en: "Energy & Technical Infrastructure",  fr: "Énergie & Infrastructures techniques" } },
    { id: "development",   icon: "Handshake",   name: { en: "Development & PPP",                  fr: "Développement & PPP" } }
  ],
  vertical: {
    badge: { en: "Strategic Vertical", fr: "Vertical stratégique" },
    name: "Space Ports",
    desc: {
      en: "Ground infrastructure for the emerging space industry — launch pads, control centers, logistics corridors.",
      fr: "Infrastructures sol pour l'industrie spatiale émergente — aires de lancement, centres de contrôle, corridors logistiques."
    }
  },
  cta: { en: "Discover AEDIS", fr: "Découvrir AEDIS" }
};

// SIRIUS — featured platform of the Smartinvest subsidiary (Tokenized Real Assets on Solana)
export const siriusPlatform = {
  url: "https://platform-staging-9.preview.emergentagent.com",
  name: "SIRIUS",
  logo: "/images/sirius-logo-white.svg",
  preview: "/images/sirius-preview.png",
  brandColor: "#4A6B8A",
  accentColor: "#7B9CC0",
  eyebrow: {
    en: "Tokenized Real Assets · Solana",
    fr: "Actifs réels tokenisés · Solana"
  },
  tagline: {
    en: "Real asset. Real value. Real impact.",
    fr: "Actif réel. Valeur réelle. Impact réel."
  },
  shortBrief: {
    en: "The institutional platform for tokenized real-asset investment on Solana. Audited assets, on-chain settlement, instant liquidity via the ATLAS secondary market.",
    fr: "La plateforme institutionnelle d'investissement en actifs réels tokenisés sur Solana. Actifs audités, règlement on-chain, liquidité immédiate via le marché secondaire ATLAS."
  },
  longBrief: {
    en: "SIRIUS is the institutional platform for tokenized real-asset investment on Solana. Seven specialized engines (real estate, infrastructure, aviation, agriculture, commodities, private debt, equity) give access to assets audited under JORC, RICS, ISTAT, IFRS 13 standards, with on-chain settlement and instant liquidity through the ATLAS secondary market.",
    fr: "SIRIUS est la plateforme institutionnelle d'investissement en actifs réels tokenisés sur Solana. Sept moteurs spécialisés (immobilier, infrastructure, aviation, agriculture, matières premières, dette privée, equity) donnent accès à des actifs audités sous standards JORC, RICS, ISTAT, IFRS 13, avec règlement on-chain et liquidité immédiate via le marché secondaire ATLAS."
  },
  engines: [
    { id: "real-estate",      icon: "Building2",  name: { en: "Real Estate",     fr: "Immobilier" } },
    { id: "infrastructure",   icon: "Factory",    name: { en: "Infrastructure",  fr: "Infrastructure" } },
    { id: "aviation",         icon: "Plane",      name: { en: "Aviation",        fr: "Aviation" } },
    { id: "agriculture",      icon: "Wheat",      name: { en: "Agriculture",     fr: "Agriculture" } },
    { id: "commodities",      icon: "Gem",        name: { en: "Commodities",     fr: "Matières premières" } },
    { id: "private-debt",     icon: "Landmark",   name: { en: "Private Debt",    fr: "Dette privée" } },
    { id: "equity",           icon: "TrendingUp", name: { en: "Equity",          fr: "Equity" } }
  ],
  standards: ["JORC", "RICS", "ISTAT", "IFRS 13"],
  features: [
    { en: "Solana on-chain settlement", fr: "Règlement on-chain Solana" },
    { en: "ATLAS secondary market — instant liquidity", fr: "Marché secondaire ATLAS — liquidité immédiate" },
    { en: "Institutional-grade audit", fr: "Audit qualité institutionnelle" }
  ],
  cta: { en: "Discover SIRIUS", fr: "Découvrir SIRIUS" }
};

// MENTIS — featured platform of the Smartlab subsidiary (Innovation, AI & R&D)
export const mentisPlatform = {
  url: "https://mentis-coherence.preview.emergentagent.com",
  name: "MENTIS",
  logo: "/images/mentis-logo.svg",
  preview: "/images/mentis-preview.png",
  eyebrow: {
    en: "External tool · Coherence instrument",
    fr: "Outil externe · Instrument de cohérence"
  },
  tagline: {
    en: "A Coherence Instrument",
    fr: "Instrument de cohérence"
  },
  pullQuote: {
    en: "Hold an idea up to the light. See its structure.",
    fr: "Levez une idée à la lumière. Voyez sa structure."
  },
  shortBrief: {
    en: "A scientific instrument that doesn't answer questions — it measures whether the structure of an idea survives. It holds a claim in superposition, exposes its tensions, and lets it collapse on its own logic.",
    fr: "Un instrument scientifique qui ne répond pas aux questions : il mesure si la structure d'une idée survit. Il maintient une affirmation en superposition, en expose les tensions, et la laisse s'effondrer sur sa propre logique."
  },
  mediumBrief: {
    en: "MENTIS is a coherence instrument. Unlike an assistant, it does not respond — it measures. You submit a complex claim; it decomposes it into 3 steps (Formulation → Superposition → Coherence State), exposes internal tensions, and delivers a structural verdict: Coherent, Incoherent, Unstable, or Incomplete. An optional quantum mode runs a real QAOA algorithm on a Qiskit simulator in parallel to confirm the measurement mathematically. Bilingual FR/EN, exportable as PDF/Markdown, citable by academic token. Made for thinkers who want geometry, not opinion.",
    fr: "MENTIS est un instrument de cohérence. Contrairement à un assistant, il ne répond pas — il mesure. Vous lui soumettez une affirmation complexe ; il la décompose en 3 étapes (Formulation → Superposition → État de cohérence), expose les tensions internes, et délivre un verdict structurel : Coherent, Incoherent, Unstable, ou Incomplete. Un mode quantique optionnel exécute en parallèle un véritable algorithme QAOA sur simulateur Qiskit pour confirmer la mesure mathématiquement. Multilingue FR/EN, exportable en PDF/Markdown, citable par token académique. Made for thinkers who want geometry, not opinion."
  },
  protocol: [
    {
      step: "01",
      name: { en: "Formulation", fr: "Formulation" },
      desc: { en: "Decompose the claim into its constituent assumptions and entities.", fr: "Décomposer l'affirmation en ses hypothèses et entités constitutives." }
    },
    {
      step: "02",
      name: { en: "Superposition", fr: "Superposition" },
      desc: { en: "Place the parts in superposition to expose latent tensions.", fr: "Placer les parties en superposition pour exposer les tensions latentes." }
    },
    {
      step: "03",
      name: { en: "Coherence State", fr: "État de cohérence" },
      desc: { en: "Measure whether the structure survives the collapse.", fr: "Mesurer si la structure survit à l'effondrement." }
    }
  ],
  verdicts: ["COHERENT", "INCOHERENT", "UNSTABLE", "INCOMPLETE"],
  signature: "C:0.84 · T:5 · V:2",
  quantumMode: {
    title: { en: "Quantum Coherence Mode", fr: "Mode de cohérence quantique" },
    desc: {
      en: "For mathematically rigorous users: two solvers in parallel — a quantum-inspired Simulated Annealer and a real QAOA algorithm on Qiskit's noiseless simulator.",
      fr: "Pour les utilisateurs mathématiquement rigoureux : deux solveurs en parallèle — un Simulated Annealer quantique-inspiré et un véritable algorithme QAOA sur le simulateur noiseless de Qiskit."
    }
  },
  features: {
    en: ["Bilingual EN/FR", "PDF & Markdown export", "Stable public share token", "Academically citable"],
    fr: ["Bilingue EN/FR", "Export PDF & Markdown", "Token de partage public stable", "Citable académiquement"]
  },
  cta: { en: "Open MENTIS", fr: "Ouvrir MENTIS" }
};

// Ocsas Pharma — featured portfolio company of the Smartlab subsidiary (Biotech / Medical Cannabis)
export const ocsasPlatform = {
  url: "https://ocsas-hub.preview.emergentagent.com/",
  name: "Ocsas Pharma",
  logo: "/images/ocsas-logo.svg",
  preview: "/images/ocsas-preview.png",
  eyebrow: {
    en: "Portfolio · Medical Cannabis",
    fr: "Portefeuille · Cannabis médical"
  },
  tagline: {
    en: "EU-GMP medical cannabis, grown where the air is thin.",
    fr: "Cannabis médical EU-GMP, cultivé là où l'air est rare."
  },
  shortBrief: {
    en: "Ocsas Pharma cultivates and processes EU-GMP medical cannabis on a 49-year concession in Rwanda's volcanic Northern Province — built for European and North American export from the first harvest.",
    fr: "Ocsas Pharma cultive et transforme du cannabis médical EU-GMP sur une concession de 49 ans dans la Province du Nord volcanique du Rwanda — conçu pour l'export européen et nord-américain dès la première récolte."
  },
  chips: [
    { en: "EU-GMP", fr: "EU-GMP" },
    { en: "49-Year Concession", fr: "Concession de 49 ans" },
    { en: "Kinigi · Rwanda", fr: "Kinigi · Rwanda" },
    { en: "Export-Ready", fr: "Prêt à l'export" }
  ],
  altitude: { value: "2,400 m", labelEn: "Virunga Foothills", labelFr: "Contreforts des Virunga" },
  cta: { en: "Visit Ocsas Pharma", fr: "Découvrir Ocsas Pharma" }
};

// POST by SmartMedia — featured platform of the Smartmedias subsidiary
export const postPlatform = {
  url: "https://smartmedia-preview.preview.emergentagent.com",
  name: "POST",
  byline: { en: "by SmartMedia", fr: "by SmartMedia" },
  tagline: {
    en: "The Africa We Know",
    fr: "L'Afrique que nous connaissons"
  },
  shortBrief: {
    en: "The premier Pan-African intelligence platform delivering verified news, in-depth analysis, and exclusive investment opportunities across 54 nations.",
    fr: "La plateforme premium d'intelligence panafricaine : actualités stratégiques, analyses approfondies et opportunités d'investissement exclusives."
  },
  longBrief: {
    en: "POST by SmartMedia is the reference platform for Pan-African economic and political intelligence. Every day, POST delivers verified analysis, in-depth dossiers and exclusive access to investment opportunities across the continent. Through POST Daily, POST Magazine and the Business Club, decision-makers have every key to understand and act on African markets.",
    fr: "POST by SmartMedia est la plateforme de référence pour l'intelligence économique et politique panafricaine. Chaque jour, POST délivre des analyses vérifiées, des dossiers approfondis et un accès exclusif aux opportunités d'investissement du continent. Avec POST Daily, POST Magazine et le Business Club, les décideurs disposent de toutes les clés pour comprendre et agir sur les marchés africains."
  },
  products: [
    { name: "POST Daily", desc: { en: "Daily intelligence briefings", fr: "Briefings quotidiens d'intelligence" } },
    { name: "POST Magazine", desc: { en: "In-depth dossiers and analysis", fr: "Dossiers et analyses approfondies" } },
    { name: "Business Club", desc: { en: "Exclusive investment access", fr: "Accès aux opportunités d'investissement" } }
  ],
  cta: { en: "Visit POST", fr: "Visiter POST" },
  preview: "/images/post-preview.png",
  previewMobile: "/images/post-mobile.png"
};

// Featured editorial — tribune Alpha Diallo on POST
export const postTribune = {
  category: { en: "TRIBUNE", fr: "TRIBUNE" },
  title: {
    en: "Africa and the Mythos Risk — What Our Banks Must Do Now",
    fr: "L'Afrique face au risque Mythos — Ce que nos banques doivent faire maintenant"
  },
  author: "Alpha Diallo",
  role: {
    en: "President & Founder, SENTINEL",
    fr: "Président & Fondateur, SENTINEL"
  },
  excerpt: {
    en: "Anthropic's 'Claude Mythos' AI represents an existential threat to global financial infrastructure. While major American and European banks have access to 'Project Glasswing', African financial institutions remain excluded. Our regulators must act within 90 days.",
    fr: "L'IA « Claude Mythos » d'Anthropic représente une menace existentielle pour l'infrastructure financière mondiale. Alors que les grandes banques américaines et européennes ont accès au « Project Glasswing », les institutions financières africaines restent exclues. Nos régulateurs doivent agir dans les 90 jours."
  },
  readMore: { en: "Read on POST", fr: "Lire sur POST" }
};

// Contact Page Content
export const contactContent = {
  title: { en: "Contact", fr: "Contact" },
  email: "contact@smartworld.group",
  infoEmail: "info@smartworldgroup.com",
  offices: { en: "Offices: Available upon request", fr: "Bureaux : disponibles sur demande" },
  website: "smartworldgroup.com"
};

// Navigation links - labels are translated via translations.nav.* below
export const navigationLinks = [
  { key: "home",         path: "/home",         icon: "Home" },
  { key: "about",        path: "/about",        icon: "Info" },
  { key: "ecosystem",    path: "/ecosystem",    icon: "Layers" },
  { key: "careers",      path: "/careers",      icon: "Briefcase" },
  { key: "partnerships", path: "/partnerships", icon: "Handshake" },
  { key: "contact",      path: "/contact",      icon: "Mail" }
];

// UI strings — all short labels, buttons, headings used by components
export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      ecosystem: "Ecosystem",
      careers: "Careers",
      partnerships: "Partnerships",
      contact: "Contact",
      companies: "Companies"
    },
    cta: {
      partnerWithUs: "Partner With Us",
      exploreEcosystem: "Explore the Ecosystem",
      contactUs: "Contact Us",
      learnMore: "Learn More",
      viewAll: "View All",
      discover: "Discover",
      enter: "Enter",
      readyToBuild: "Ready to Build Together?",
      readyToBuildSub: "Join us in shaping Africa's integrated future."
    },
    footer: {
      rights: "All rights reserved.",
      navigation: "Navigation",
      ecosystem: "Ecosystem",
      tagline: "Building Africa's Integrated Future. Real assets. Digital infrastructure. Long-term vision."
    },
    splash: {
      tagline: "Building Africa's Integrated Future.",
      sub: "Real assets. Digital infrastructure. Long-term vision.",
      hint: "Pan-African Holding Company"
    },
    home: {
      ourPortfolio: "Our Portfolio",
      ourPortfolioSub: "Eight specialized companies, one integrated ecosystem",
      ourMission: "Our Mission",
      leadership: "Leadership",
      whatTheySay: "What They Say"
    },
    video: {
      eyebrow: "In Motion",
      title: "Smartworld Group in Motion",
      subtitle: "A glimpse into the projects, people and ambition shaping a Pan-African future.",
      play: "Play video",
      pause: "Pause video",
      mute: "Mute",
      unmute: "Unmute"
    },
    sections: {
      timeline: "Timeline",
      milestones: "Key milestones",
      ourLeadership: "Our Leadership",
      testimonials: "Testimonials"
    },
    ecosystem: {
      overview: "Overview",
      interconnections: "Interconnections"
    },
    subsidiary: {
      coreActivities: "Core Activities",
      strategicFocus: "Strategic Focus",
      valueProposition: "Value Proposition",
      principle: "Our Guiding Principle",
      backToEcosystem: "Back to Ecosystem",
      nextCompany: "Next Company"
    },
    careers: {
      hero: "Join Our Team",
      contactCta: "Send us your CV"
    },
    partnerships: {
      hero: "Let's Build Together",
      contactCta: "Get in Touch"
    },
    contact: {
      title: "Get in Touch",
      subtitle: "Have questions about Smartworld Group or interested in partnership opportunities? We'd love to hear from you.",
      sectionTitle: "Contact Information",
      directly: "Reach Out Directly",
      emailLabel: "Email",
      officesLabel: "Offices",
      careersIntro: "For career opportunities, please contact:",
      formTitle: "Send a Message",
      name: "Name",
      email: "Email",
      company: "Company",
      subject: "Subject",
      message: "Message",
      namePh: "Your name",
      emailPh: "your@email.com",
      companyPh: "Your company",
      messagePh: "How can we help you?",
      selectSubject: "Select a subject",
      partnership: "Partnership Inquiry",
      investment: "Investment Inquiry",
      general: "General Inquiry",
      careers: "Careers",
      media: "Media & Press",
      send: "Send Message",
      sending: "Sending...",
      successTitle: "Message Sent!",
      successSub: "We'll get back to you as soon as possible.",
      errorGeneric: "An error occurred. Please try again."
    },
    newsletter: {
      title: "Stay Updated",
      sub: "Subscribe to our newsletter for the latest news and updates from Smartworld Group.",
      placeholder: "Enter your email",
      subscribe: "Subscribe",
      subscribing: "Subscribing...",
      subscribed: "Subscribed!",
      errorGeneric: "Subscription failed. Please try again."
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      ecosystem: "Écosystème",
      careers: "Carrières",
      partnerships: "Partenariats",
      contact: "Contact",
      companies: "Entreprises"
    },
    cta: {
      partnerWithUs: "Devenez Partenaire",
      exploreEcosystem: "Explorer l'écosystème",
      contactUs: "Contactez-nous",
      learnMore: "En savoir plus",
      viewAll: "Voir tout",
      discover: "Découvrir",
      enter: "Entrer",
      readyToBuild: "Prêts à bâtir ensemble ?",
      readyToBuildSub: "Rejoignez-nous pour construire l'avenir intégré de l'Afrique."
    },
    footer: {
      rights: "Tous droits réservés.",
      navigation: "Navigation",
      ecosystem: "Écosystème",
      tagline: "Construire l'avenir intégré de l'Afrique. Actifs réels. Infrastructure numérique. Vision long terme."
    },
    splash: {
      tagline: "Construire l'avenir intégré de l'Afrique.",
      sub: "Actifs réels. Infrastructure numérique. Vision long terme.",
      hint: "Holding panafricaine"
    },
    home: {
      ourPortfolio: "Notre Portefeuille",
      ourPortfolioSub: "Huit entreprises spécialisées, un écosystème intégré",
      ourMission: "Notre Mission",
      leadership: "Direction",
      whatTheySay: "Ils en parlent"
    },
    video: {
      eyebrow: "En images",
      title: "Smartworld Group en mouvement",
      subtitle: "Un aperçu des projets, des femmes et des hommes qui dessinent l'avenir panafricain.",
      play: "Lire la vidéo",
      pause: "Pause",
      mute: "Couper le son",
      unmute: "Activer le son"
    },
    sections: {
      timeline: "Chronologie",
      milestones: "Étapes clés",
      ourLeadership: "Notre Direction",
      testimonials: "Témoignages"
    },
    ecosystem: {
      overview: "Vue d'ensemble",
      interconnections: "Interconnexions"
    },
    subsidiary: {
      coreActivities: "Activités principales",
      strategicFocus: "Focus stratégique",
      valueProposition: "Proposition de valeur",
      principle: "Notre principe directeur",
      backToEcosystem: "Retour à l'écosystème",
      nextCompany: "Entreprise suivante"
    },
    careers: {
      hero: "Rejoignez notre équipe",
      contactCta: "Envoyez-nous votre CV"
    },
    partnerships: {
      hero: "Bâtissons ensemble",
      contactCta: "Entrer en contact"
    },
    contact: {
      title: "Entrer en contact",
      subtitle: "Vous avez des questions sur Smartworld Group ou souhaitez explorer une opportunité de partenariat ? Nous serions ravis d'échanger.",
      sectionTitle: "Informations de contact",
      directly: "Nous contacter directement",
      emailLabel: "Email",
      officesLabel: "Bureaux",
      careersIntro: "Pour les opportunités de carrière, contactez :",
      formTitle: "Envoyer un message",
      name: "Nom",
      email: "Email",
      company: "Entreprise",
      subject: "Sujet",
      message: "Message",
      namePh: "Votre nom",
      emailPh: "votre@email.com",
      companyPh: "Votre entreprise",
      messagePh: "Comment pouvons-nous vous aider ?",
      selectSubject: "Choisissez un sujet",
      partnership: "Demande de partenariat",
      investment: "Demande d'investissement",
      general: "Demande générale",
      careers: "Carrières",
      media: "Médias & Presse",
      send: "Envoyer le message",
      sending: "Envoi...",
      successTitle: "Message envoyé !",
      successSub: "Nous reviendrons vers vous dans les plus brefs délais.",
      errorGeneric: "Une erreur est survenue. Veuillez réessayer."
    },
    newsletter: {
      title: "Restez informés",
      sub: "Inscrivez-vous à notre newsletter pour recevoir les actualités et nouveautés de Smartworld Group.",
      placeholder: "Votre email",
      subscribe: "S'inscrire",
      subscribing: "Inscription...",
      subscribed: "Inscrit !",
      errorGeneric: "L'inscription a échoué. Veuillez réessayer."
    }
  }
};
